import 'lightgallery.js';
import 'lg-fullscreen.js';
import 'lg-thumbnail.js';
import 'lg-hash.js';
import 'lg-video.js';
// import 'lg-share.js';

class Gallery {

    constructor() {
        this.Selectors = {
            galleryWrapper: '#lightgallery'
        };
        this.Options = {
            lightGalleryConfiguration: {
                thumbnail: true,
                fullScreen: true,
                selector: '.gallery-assetlist-small-element',
                subHtmlSelectorRelative: true,
                autoplayFirstVideo: false
            }
        };

        let $gallery = $(this.Selectors.galleryWrapper);
        if (!$gallery.length) {
            return;
        }
        lightGallery($gallery[0], this.Options.lightGalleryConfiguration);
        // $gallery.lightGallery(this.Options.lightGalleryConfiguration);
    }
}

export default Gallery;